import SphButton from './Button.vue';

export type { ButtonDefaults } from './defaults';
export { provideButtonDefaults } from './defaults';
export { SphButton };
export default SphButton;
